module.exports = __webpack_public_path__ + "static/img/edu.29903aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edu.png
// module id = RSkU
// module chunks = 1